type Listener = (payload: unknown) => void;

const EVENT_TYPES = {
  CLIENT_CHANGE: 'client:change',
  CLIENT_REFRESH: 'client:refresh',
  CLIENT_FAVORITE: 'client:favorite',
  TOGGLE_SIDENAV: 'ui:toggle-sidenav',
  POPUP_CLOSED: 'ui:popup-closed',
  USER_LOGOUT: 'auth:logout',
  LOGIN_SUCCESS: 'auth:login-success',
} as const;

class EventBus {
  readonly EventTypes = EVENT_TYPES;

  private readonly listeners = new Map<string, Set<Listener>>();

  on<T = unknown>(event: string, callback: (payload: T) => void): () => void {
    let set = this.listeners.get(event);
    if (!set) {
      set = new Set();
      this.listeners.set(event, set);
    }
    const listener = callback as Listener;
    set.add(listener);
    return () => set!.delete(listener);
  }

  emit<T = unknown>(event: string, payload?: T): void {
    this.listeners.get(event)?.forEach((cb) => {
      try {
        cb(payload);
      } catch (err) {
        // event name is logged as a separate argument (not interpolated into
        // the format string) to avoid log-injection findings. Untrusted event
        // names cannot break the log line structure.
        console.error('[shell.events] listener threw for event:', event, err);
      }
    });
  }
}

export const eventsModule = new EventBus();
